import React, { Fragment } from "react";
import FormControl from "@mui/material/FormControl";
import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { useLicenseTypes } from "../../vocabularyServices";
import { Skeleton } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import { anyTrue, notBlank } from "../../../util/ext";
import { identity, ifElse, reject, propEq, is, find, includes } from "ramda";
import {
  useCurrentOrgId,
  useIsAdmin,
  useIsIapReviewer,
} from "../../../auth/authUtils";
import { isBlank } from "../../../util/ext";

const OHIO_LINK_ORGS = [
  "ba6600f0-842b-442c-aa5b-8208f2f999fc", // Offices org
  "f828e3f7-81f4-40b9-a06a-ce05cba95c3f", // Members org
];
const withoutOhioLinkLicense = reject(propEq("code", "OHIO_LINK_CP"));

const LicenseTypeSelect = props => {
  const {
    onBlur,
    onChange,
    value,
    required = false,
    error = false,
    helperText = "",
  } = props;
  const currentOrgId = useCurrentOrgId();
  const licenseTypes = useLicenseTypes();
  const isAdmin = useIsAdmin();
  const isIapReviewer = useIsIapReviewer();

  return (
    <Fragment>
      {licenseTypes.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <Autocomplete
            id="content-licenseType"
            value={value || ""}
            onChange={onChange}
            options={ifElse(
              () => anyTrue([isAdmin, includes(currentOrgId, OHIO_LINK_ORGS)]),
              identity,
              withoutOhioLinkLicense,
            )(licenseTypes.data)}
            getOptionLabel={option => {
              if (isBlank(option)) {
                return "";
              } else if (is(Object, option)) {
                return option.displayName;
              } else {
                const lt = find(
                  lt => includes(option, [lt.id, lt.name, lt.code]),
                  licenseTypes.data,
                );
                return lt?.displayName ?? lt.name;
              }
            }}
            isOptionEqualToValue={(lt, val) =>
              notBlank(val) && lt.id === val.id
            }
            renderInput={params => {
              params.inputProps["aria-autocomplete"] = "none";
              params.inputProps["id"] = "content-licenseType";
              return (
                <TextField
                  {...params}
                  disabled={isIapReviewer}
                  required={required}
                  error={error}
                  type="text"
                  onBlur={onBlur}
                  name="content-LicenseType"
                  fullWidth
                  label="License Type"
                />
              );
            }}
          />
          {notBlank(error) && (
            <FormHelperText error>{helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    </Fragment>
  );
};

export default LicenseTypeSelect;
